import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

import { APIService } from '../shared/service/api.service';
import { PagerService } from '../shared/service';
import { Instituicao } from '../models/instituicao';
import { siglaMAP } from '../shared/enums/UFEnum';
import { removeAccents } from '../shared/function/remove-accents';
import { treatsNullUndefinedEmpyt } from '../shared/function/treats-null-undefined-empyt';
import { SpinnerService } from '../shared/spinner/spinner.service';

@Component({
  selector: 'app-instituicoes-ensino',
  templateUrl: './instituicoes-ensino.component.html',
  styleUrls: ['./instituicoes-ensino.component.scss'],
})
export class InstituicoesEnsinoComponent implements OnInit {
  componenteRef = 'instituicoes-ensino';
  instituicoes?: Instituicao[];
  pageOfItems: Array<any>;
  nomeCurso: string;
  siglaUF: string;
  codMunicipio: string;
  totalResultados: number;
  queryParamsSubscription: Subscription;
  realizouBusca = false;
  error = false;
  ordecao: any;
  filtro: any;
  eixo: any;
  stringPesquisa: string;
  pager: any = {};
  pagedItems: any[];
  ufs = siglaMAP;
  fileName: any = 'instituicoes_ofertantes_cnct';
  msgSemInstituicao = false;
  fileCSV: any = '';
  encoding = 'ISO-8859-1';
  searchInstituicao: string;
  instituicoesTemp?: Instituicao[];
  cidadeSelecionada?: string;

  constructor(
    private api: APIService,
    private route: ActivatedRoute,
    private pagerService: PagerService,
    private spinnerService: SpinnerService
  ) { }

  // Modelo do filtro
  filtros: { [key: string]: string } = {
    nome: '',
    uf: '',
    cidade: ''
  };

  ngOnInit(): void {
    this.getInstituicoes();
  }

  /**
   *
   */
  async getInstituicoes() {
    this.spinnerService.show();

    this.route.queryParams.subscribe((q) => {
      this.nomeCurso = q.query ? q.query : 'undefined';
      this.nomeCurso = q.nomeCurso ? q.nomeCurso : 'undefined';
    });

    this.api.getInstituicosPorCurso(this.nomeCurso)
      .subscribe((instituicoes: Instituicao[]) => {
        this.instituicoesTemp = instituicoes; // Faz cache das instituições.
        this.montaDadosPaginaInstituicoes(instituicoes);
        this.spinnerService.hide();
      });
  }

  /**
   * @param page número da página.
   * @returns itens de página.
   */
  setPage(page: number): void {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // pega o objeto pager do serviço
    this.pager = this.pagerService.getPager(this.instituicoes.length, page);
    // pega a página atual de itens
    this.pagedItems = this.instituicoes.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  exportToCsv(): void {
    this.api.getDownloadCsvInstituicoesOfertantesByCurso(this.nomeCurso, this.encoding)
      .subscribe((data: any) => {
        const blob = new Blob([data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.fileName + '.csv'; // Substitua pelo nome desejado do arquivo
        link.click();
      },
        error => {
          console.error('Erro ao baixar o CSV de instituições ofertantes.', error);
        });
  }

  /**
   *
   * @param instituicoes de ensino.
   */
  montaDadosPaginaInstituicoes(instituicoes: Instituicao[]): void {
    if (instituicoes && instituicoes.length > 0) {
      this.instituicoes = instituicoes;
      this.setPage(1);
      this.totalResultados = this.instituicoes.length;
      this.msgSemInstituicao = false;
    } else {
      this.totalResultados = null;
      this.instituicoes = [];
      this.pager = {};
      this.pagedItems = [];
      this.msgSemInstituicao = true;
    }
  }

  /**
   *
   * @param input para consulta do cache.
   */
  buscaInstituicao(input: any[]): void {
    if (this.instituicoesTemp && this.instituicoesTemp.length > 0) {
      this.instituicoes = this.instituicoesTemp;
    }

    this.realizouBusca = true;
    [this.searchInstituicao, this.siglaUF, this.cidadeSelecionada] = input;
    // console.debug(this.searchInstituicao, this.siglaUF, this.cidadeSelecionada);

    const filtrosAplicados = {
      nome: treatsNullUndefinedEmpyt(this.searchInstituicao),
      uf: treatsNullUndefinedEmpyt(this.siglaUF),
      cidade: treatsNullUndefinedEmpyt(this.cidadeSelecionada)
    };

    this.instituicoes = this.getInstituicoesFiltradas(filtrosAplicados);
    this.montaDadosPaginaInstituicoes(this.instituicoes);
  }

  /**
   *
   * @param filtros dinâmicos para consulta de instituição.
   * @returns Instituicao válida.
   */
  getInstituicoesFiltradas(filtros: { [key: string]: string }): Instituicao[] {
    // console.debug('Buscando dados de cache com filtro em getInstituicoesFiltradas:', filtros);
    return this.instituicoes.filter(instituicao =>
      (filtros.nome ? removeAccents(instituicao.nome).includes(removeAccents(filtros.nome)) : true)
      &&
      (filtros.uf ? removeAccents(instituicao.uf).includes(removeAccents(filtros.uf)) : true)
      &&
      (filtros.cidade ? removeAccents(instituicao.cidade).includes(removeAccents(filtros.cidade)) : true)
    ).map(instituicao => instituicao);
  }

  /**
   * @param recebe parâmetro input do filho para acionar o olinda.
   */
  buscaInformacoesInstituicaoOlinda(input: any[]): void {
    // console.debug('Buscando dados do olinda:', input);

    this.realizouBusca = true;
    [this.nomeCurso, this.siglaUF, this.codMunicipio] = input;

    this.montaDadosPaginaInstituicoes(this.instituicoes);

    let http: Observable<Instituicao[]>;

    if (this.nomeCurso && this.siglaUF && this.codMunicipio) {
      http = this.api.getInstituicosPorCursoUFeMunicipio(
        this.nomeCurso,
        this.siglaUF,
        this.codMunicipio
      ); // Curso Uf Cod Municipio
    } else if (this.nomeCurso && this.siglaUF && !this.codMunicipio) {
      http = this.api.getInstituicosPorCursoUF(this.nomeCurso, this.siglaUF); // Curso e UF
    } else {
      http = this.api.getInstituicosPorCurso(this.nomeCurso); // Todas as instituições pelo Curso
    }

    /**
     *
     */
    http.subscribe((instituicoes: Instituicao[]) => {
      this.montaDadosPaginaInstituicoes(instituicoes);
    });
  }

  /**
   * @param recebe parâmetro input do filho para procurar instituição.
   */
  buscaInformacoesInstituicaoCache(input: any[]): void {
    // console.debug('2: Buscando dados do cache:', input);

    this.realizouBusca = true;
    [this.searchInstituicao, this.siglaUF, this.codMunicipio] = input;

    this.buscaInstituicao(input);
  }

  /**
   *
   * @param recebe parâmetro input do filho para listar as instituições do cache.
   */
  listaTodasInstituicaoCache(input: any[]): void {
    // console.debug('Listando todas as instituições do cache:', input);
    // [this.searchInstituicao, this.siglaUF, this.codMunicipio] = input;
    this.instituicoes = this.instituicoesTemp;
    this.montaDadosPaginaInstituicoes(this.instituicoes);
  }


}
